import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  Button,
  Grid,
  Toolbar,
} from "@mui/material";
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Popups = ({ open, onClose, onAction, actions, title, ...rest }) => {
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      //   onClose={onClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          <Grid className="d-flex justify-content-around">
            {actions?.map((action, index) => (
              <Toolbar key={index} className="p-0">
                <Button
                  className="button"
                  variant={action?.variant || "contained"}
                  color={action?.color || "primary"}
                  sx={{ mr: 1 }}
                  onClick={() => onAction(action?.id)}
                >
                  {action?.label}
                </Button>
              </Toolbar>
            ))}
          </Grid>
        </DialogContentText>
      </DialogContent>
      {rest?.deleteButton === false ? (
        <div className="d-flex justify-content-around mb-2 mt-3">
          <Button onClick={onClose} variant="contained" color="error">
            Back
          </Button>
        </div>
      ) : (
        ""
      )}
    </Dialog>
  );
};

export default Popups;
